import apiService from '../apiService';

/** Export approval (OL-154): the Export Requests page and the approved download. */
const exportRequestService = {
    async list() {
        try {
            const response = await apiService.get('/export-requests');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    async approve(id, note = '') {
        try {
            const response = await apiService.post(`/export-requests/${id}/approve`, { note });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    async reject(id, note = '') {
        try {
            const response = await apiService.post(`/export-requests/${id}/reject`, { note });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    /**
     * An approved export is downloaded from the endpoint it was requested on;
     * the server swaps in the approved parameters, so only the id is sent.
     */
    async download(replayPath, id) {
        try {
            const response = await apiService.post(replayPath, { export_request: id }, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
};

export default exportRequestService;
